/**
 * Contesto utente: login, registrazione, logout, stato autenticazione.
 */
import { createContext, useContext, useState, useEffect } from 'react';
import api from '../lib/api.js';

export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  async function fetchMe() {
    try {
      const res = await api.get('/auth/me');
      if (res.ok) setUser(res.data);
      else setUser(null);
    } catch { setUser(null); }
    finally { setLoading(false); }
  }

  useEffect(() => { fetchMe(); }, []);

  async function login({ email, password, pin }) {
    const res = await api.post('/auth/login', { email, password, pin });
    if (!res.ok) throw new Error(res.error || 'Credenziali non valide');
    setUser(res.data.user);
    return res.data.user;
  }

  async function register({ email, password, pin }) {
    const res = await api.post('/auth/register', { email, password, pin });
    if (!res.ok) throw new Error(res.error || 'Registrazione fallita');
    setUser(res.data.user);
    return res.data.user;
  }

  async function logout() {
    await api.post('/auth/logout');
    setUser(null);
    window.location.href = '/login';
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth deve essere usato dentro AuthProvider');
  return ctx;
}

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-4 text-surface-4">Caricamento...</div>;
  if (!user) {
    window.location.href = '/login';
    return null;
  }
  return children;
}